import { render, staticRenderFns } from "./MultiplesTratamientos.vue?vue&type=template&id=2be7553c&scoped=true"
import script from "./MultiplesTratamientos.vue?vue&type=script&lang=js"
export * from "./MultiplesTratamientos.vue?vue&type=script&lang=js"
import style0 from "./MultiplesTratamientos.vue?vue&type=style&index=0&id=2be7553c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be7553c",
  null
  
)

export default component.exports